module.exports = __webpack_public_path__ + "img/state-img.92bf1a46.png";